module.exports = __webpack_public_path__ + "static/media/timer.faf74aa2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicContent/About/timer.svg
// module id = 741
// module chunks = 0